/* eslint-disable import/prefer-default-export */

export const sortBookings = (stops) => {
  return stops.map((stop) => {
    const pickups = stop.bookings
      .filter((b) => b.stop_type === 'pickup')
      .sort((a, b) => a.passenger_firstname.localeCompare(b.passenger_firstname));

    const dropoffs = stop.bookings
      .filter((b) => b.stop_type === 'dropoff')
      .sort((a, b) => a.passenger_firstname.localeCompare(b.passenger_firstname));

    return {
      ...stop,
      bookings: [...pickups, ...dropoffs],
    };
  });
};
